
import { bus } from '~/assets/js/eventBus'
import imgText from '~/components/comments/imgtext.vue'
import releaseSuccessDialog from '~/components/detail/releaseSuccessDialog.vue'
import WikiGeet from '~/components/common/wikiGeet.vue'
export default {
  components: {
    imgText,
    'wiki-geet': WikiGeet,
    releaseSuccessDialog
  },
  inject: ['code'],
  props: {
    isEvaluateDialog: {
      type: Boolean,
      default: false
    },
    isPublish: {
      type: String,
      default: '1' // 默认1 评价 2 调解
    },
    // 项目类型 1 交易商  6 服务商
    typeVal: {
      type: Number,
      default: 6
    },
    gradetypeList: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const _poorsArr = this.gradetypeList?.gradeNegative || []
    const _reviewList = this.fixGradeTypeList(this.gradetypeList)
    // console.log('_poorsArr', _poorsArr)
    // console.log('_reviewList', _reviewList)
    return {
      lan: this.$store.state.LanguageCode,
      actvieVal: '',
      radioPoor: '',
      titleVal: '',
      radioIndex: '',
      isEnterMediate: false, // 是否可进入交易商
      isQueue: false, // 是否在排队中
      isSuccessDialog: false,
      isSync: true,
      publishDataObj: {},
      reviewList: _reviewList || [],
      poorsArr: _poorsArr || [],
      content: '',
      imgList: [],
      isPublish2: this.isPublish,
      showDrag: false, // 极验开关
      product: 'bind'
    }
  },
  computed: {
    isDisabled() {
      if (this.isPublish === '1' && this.isPublish2 === '1') {
        if (this.typeVal == 6 && this.actvieVal !== '') {
          return true
        } else if (this.typeVal == 1 && this.actvieVal !== '' && ((this.actvieVal === '3' && this.radioPoor) || this.actvieVal !== '3')) {
          return true
        } else {
          return false
        }
      } else if (this.radioPoor) {
        return true
      } else {
        return false
      }
    },
    // 用户是否登录
    isLogin() {
      return this.$store.state?.user?.userId || ''
    }
  },
  watch: {
    isEvaluateDialog(newVal) {
      if (newVal && !(this.reviewList?.length > 0)) {
        this.initeCatePoor()
      }
    }
  },
  mounted() {
    bus.$on('openEvaluateDialog', (kg) => {
      // 发曝光/评价
      if (this.typeVal == 6) {
        this.isPublish2 = '1'
      } else {
        this.isPublish2 = kg == 2 ? '2' : '1'
      }
    })
    bus.$on('openEvaluateDialog2', (_actvieVal) => {
      this.isPublish2 = '1'
      this.actvieVal = _actvieVal
    })
    console.log('isEvaluateDialog', this.isEvaluateDialog)
  },
  beforeDestroy() {
    this.isPublish2 = '1'
  },
  methods: {
    async sendVCode(data) {
      if (!data?.captcha_id) {
        this.$refs.jiyan.gtCaptcha()
        return
      }

      const res = await this.$api.common.CV3(
        {
          lot_number: data.lot_number,
          captcha_output: data.captcha_output,
          pass_token: data.pass_token,
          gen_time: data.gen_time,
          userId: this.isLogin,
          code: '',
          type: 2,
          cide: ''
        },
        {
          Routes: 'wikicommunity$validategeettestorcode4'
        }
      )

      const rest = res?.wikicommunity?.validategeettestorcode4?.success
      if (rest) {
        // 验证成功
        this.showDrag = false
        this.isRequest = false
        this.publishClick()
      }
    },
    geetError() {
      this.isRequest = false
      this.showDrag = false
    },
    closeGeet() {
      this.isRequest = false
      this.showDrag = false
    },
    activeClick(obj) {
      this.actvieVal = obj.code
      if (obj.code !== '3') {
        this.radioPoor = ''
        this.radioIndex = ''
      }
    },
    // 获取曝光类型数据
    initeCatePoor() {
      this.$api.common
        .CV3(
          {
            objectType: this.typeVal,
            code: this.code
          },
          {
            Routes: 'wikicommunity$pulishfxgradepage'
          }
        )
        .then((res) => {
          const data = res?.wikicommunity?.pulishfxgradepage?.data
          this.poorsArr = data?.gradeNegative || []
          this.reviewList = this.fixGradeTypeList(data)
          console.log('this.reviewList', this.reviewList)
        })
    },
    fixGradeTypeList(data) {
      const gradeArr = data?.grade || []
      gradeArr?.sort(function (a, b) {
        return b.code - a.code
      })
      gradeArr?.forEach((it) => {
        switch (it.code) {
          case '1':
            it.img = 'https://resources1.interface003.com/web20/img/commen/good.svg'
            it.activeImg = 'https://resources1.interface003.com/web20/img/commen/good_active.gif'
            break
          case '2':
            it.img = 'https://resources1.interface003.com/web20/img/commen/middle.svg'
            it.activeImg = 'https://resources1.interface003.com/web20/img/commen/middle_active.gif'
            break
          case '3':
            it.img = 'https://resources1.interface003.com/web20/img/commen/bad.svg'
            it.activeImg = 'https://resources1.interface003.com/web20/img/commen/bad_active.gif'
            break
          default:
            break
        }
      })
      return gradeArr || []
    },
    keydownVal(val) {
      if (val.length > 50) {
        this.$nextTick((e) => {
          this.titleVal = val.substr(0, 50)
        })
        this.$message({
          message: this.$v('字数超出限制'),
          type: 'warning'
        })
      }
    },
    // 选择类型
    selectTypeClick(item, index) {
      this.radioIndex = index
      this.radioPoor = item.code
    },
    closeDialog() {
      this.radioIndex = ''
      this.actvieVal = ''
      this.radioPoor = ''
      this.titleVal = ''
      this.content = ''
      this.imgList = []
      this.isPublish2 = '1'
      this.$emit('closeDialog')
      const vmode = document.getElementsByClassName('v-modal')[0]
      if (vmode) {
        vmode.style.display = 'none'
      }
    },
    colseSuccessDialogFn() {
      this.isSuccessDialog = false
      this.$emit('publishSuccessClose')
      const vmode = document.getElementsByClassName('v-modal')[0]
      if (vmode) {
        vmode.style.display = 'none'
      }
    },
    publishClick() {
      this.content = this.content?.trim()
      if (!this.content) {
        this.$Toast({
          message: this.$v('您还没有填写评价内容'),
          position: 'middle'
        })
        return false
      }
      if (this.imgList.length === 0) {
        this.$Toast({
          message: this.$v('您还没有添加图片'),
          position: 'middle'
        })
        return false
      }

      if (this.isRequest) return false
      this.isRequest = true
      const data = {
        userId: this.isLogin,
        code: this.code,
        title: this.titleVal,
        content: this.content,
        images: this.imgList,
        grade: parseInt(this.actvieVal || (this.radioPoor ? '3' : '0')),
        objectType: this.typeVal,
        negativeTypeCode: this.radioPoor || 0,
        isSyncToPosts: this.isSync
      }
      if (this.isPublish === '2') {
        delete data.isSyncToPosts
      }
      let ret = ''
      this.$api.common
        .CV3(data, {
          Routes: 'wikicommunity$pulishfxgrade'
        })
        .then((res) => {
          let tempData = ''
          ret = res
          const data = res?.wikicommunity?.pulishfxgrade?.data
          console.log('发帖返回:', data)
          if (data?.isOpenGeeTest) {
            this.isRequest = false
            this.sendVCode(1)
            return false
          }
          if (res?.wikicommunity?.pulishfxgrade?.errorCode === 200) {
            this.$emit('success')
            this.closeDialog()
            setTimeout(() => {
              this.isSuccessDialog = true
            }, 800)
            this.isQueue = false
            this.isEnterMediate = false
            tempData = res.wikicommunity?.pulishfxgrade?.data || {}
            this.publishDataObj = res.wikicommunity?.pulishfxgrade?.data
            if (tempData.whiteListType == 0) {
              // =0 表示不属于 大小白名单 也就是非合作商户
              this.isShowClose = false
            }
            if (tempData.whiteListType !== 0 && tempData.status === 1) {
              this.isEnterMediate = true
              this.isShowClose = true
            }
            if (tempData.whiteListType === 2 && tempData.status === 0) {
              this.isShowClose = false
              this.isQueue = true
            }
          }
          this.isRequest = false
        })
        .catch((err) => {
          this.isRequest = false
          this.$fxlog(`发布评价,提交异常,${err},入参:${JSON.stringify(data)},返回:${JSON.stringify(ret)}`, window.location.href, this.$store.state.LanguageCode, '', ret && ret.message && !ret.succeed ? 'ERROR' : '')
        })
    },
    tongbuClick() {
      this.isSync = !this.isSync
    },
    changeImgContentFn(txtimg) {
      this.content = txtimg?.content || ''
      this.imgList = txtimg?.imglist || []
    },
    // 进入到申请调解页
    enterMediatePage() {
      this.isSuccessDialog = false
      window.open(`/${this.$store.state.LanguageCode}/exposure/onetoone/${this.publishDataObj.commentGradeId}.html`)
    }
  }
}
